import React from "react";

import "../../assets/css/bootstrap.min.css";
import "../../assets/css/all.min.css";
import "../../assets/css/swiper-bundle.min.css";
import "../../assets/css/magnific-popup.css";
import "../../assets/css/animate.css";
import "../../assets/css/nice-select.css";
import "../../assets/css/style.css";

import { Link } from 'react-router-dom';

const Statistics = () => {
  return (
    <div>


      <section className="statistic-area pt-60">
        <div className="container">
          <div className="row g-4">
            <div className="col-xl-1"></div>
            <div className="col-xl-5">
              <div className="image">
                <img
                  src="/images/service/service-three-image3.png"
                  alt="leaf"
                />
              </div>
            </div>
            <div className="col-xl-5">
              <div className="section-header2">
                <h2
                  className="wow fadeInUp"
                  data-wow-duration="1.2s"
                  data-wow-delay=".2s"
                >
                  TREE PLANTING
                </h2>
                <h5
                  className="wow fadeInUp pt-10"
                  data-wow-duration="1.4s"
                  data-wow-delay=".4s"
                >
                  Today's Environmental Protection Safeguards Tomorrow
                </h5>

              </div>
              <div className="row g-4">
                <ul
                  className="wow mt-4 fadeInDown"
                  data-wow-duration="1.2s"
                  data-wow-delay=".2s"
                >
                  <li>
                    <img
                      className="pe-2"
                      src="/images/icon/leaf.png"
                      alt="icon"
                      style={{ display: "inline" }}
                    />
                    Planting & tracking bring transparency to the tree tagging space. All trees planted
                    are documented and tracked since planting.
                  </li>


                  <li>
                    <img
                      className="pe-2"
                      src="/images/icon/leaf.png"
                      alt="icon"
                      style={{ display: "inline" }}
                    />
                    Allows tree planting programs and donors to confirm that trees have been planted.
                  </li>
                  <li>
                    <img
                      className="pe-2"
                      src="/images/icon/leaf.png"
                      alt="icon"
                      style={{ display: "inline" }}
                    />
                    Trees can be monitored as individuals to ensure their survival to the sapling stage
                    and continue to provide meaningful ecological benefits for their local environment.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="statistic-area">
        <div className="container">
          <div className="row g-4">
            <div className="col-xl-1"></div>
            <div className="col-xl-5">
              <div className="section-header2">
                <h2
                  className="wow fadeInUp "
                  data-wow-duration="1.2s"
                  data-wow-delay=".2s"
                >

                  TRACKING & VERIFICATION
                </h2>
                <h5
                  className="wow fadeInUp pt-10"
                  data-wow-duration="1.4s"
                  data-wow-delay=".4s"
                >
                  Tree Tracking & Verification for a Sustainable Tomorrow
                </h5>

              </div>
              <div className="row g-4">
                <ul
                  className="wow mt-4 fadeInDown"
                  data-wow-duration="1.2s"
                  data-wow-delay=".2s"
                >

                  <li>
                    <img
                      className="pe-2"
                      src="/images/icon/leaf.png"
                      alt="icon"
                      style={{ display: "inline" }}
                    />
                    Your tree photo is reviewed by our team. Eligible planters are paid based on the
                    confirmation of their stewardship.
                  </li>


                  <li>
                    <img
                      className="pe-2"
                      src="/images/icon/leaf.png"
                      alt="icon"
                      style={{ display: "inline" }}
                    />
                    Tree farmers can submit periodic photos tagged with a GPS of their trees. Our team
                    verifies these pictures, and farmers are paid.
                  </li>
                  <li>
                    <img
                      className="pe-2"
                      src="/images/icon/leaf.png"
                      alt="icon"
                      style={{ display: "inline" }}
                    />
                    Our data-driven system shifts the focus from simply planting trees to growing
                    diverse, thriving forests. We track incremental growth at every step and package
                    information into a tree wallet, accessible and tradable by users globally.
                  </li>
                </ul>
              </div>
            </div>

            <div className="col-xl-6">
              <div className="image">
                <img
                  src="/images/service/service-three-image4.png"
                  alt="service"
                />
              </div>
            </div>
          </div>
        </div>
      </section>










      <section className="statistic-area">
        <div className="container">
          <div className="row g-4">
            <div className="col-xl-1"></div>
            <div className="col-xl-5">
              <div className="image">
                <img
                  src="/images/service/service-three-image5.png"
                  alt="leaf"
                />
              </div>
            </div>
            <div className="col-xl-5">
              <div className="section-header2">
                <h2
                  className="wow fadeInUp"
                  data-wow-duration="1.2s"
                  data-wow-delay=".2s"
                >
                  TREE TAGGING
                </h2>
                <h5
                  className="wow fadeInUp pt-10"
                  data-wow-duration="1.4s"
                  data-wow-delay=".4s"
                >
                  Nurturing Nature, Tree Tagging for a Greener Legacy
                </h5>

              </div>
              <div className="row g-4">
                <ul
                  className="wow mt-4 fadeInDown"
                  data-wow-duration="1.2s"
                  data-wow-delay=".2s"
                >
                  <li>
                    <img
                      className="pe-2"
                      src="/images/icon/leaf.png"
                      alt="icon"
                      style={{ display: "inline" }}
                    />
                    The uses of tags vary widely and can be used to identify trees for conservation, trees
                    that have been treated, species & genus names, and memorial trees.
                  </li>


                  <li>
                    <img
                      className="pe-2"
                      src="/images/icon/leaf.png"
                      alt="icon"
                      style={{ display: "inline" }}
                    />
                    Tree tags are widely used by forestry departments, researchers, tree farmers,
                    national and local parks, landscapers, and more.
                  </li>
                  <li>
                    <img
                      className="pe-2"
                      src="/images/icon/leaf.png"
                      alt="icon"
                      style={{ display: "inline" }}
                    />
                    All tags can be fully customized, from stamped serial numbers to laser-etched QR
                    codes. Our UV-stable black aluminum tags are designed to last for years in the sun
                    and outdoors.
                  </li>
                </ul>
              </div>
              <div><br></br></div>
              {/* <a
                href="/upload"
                className="btn-one wow fadeInUp"
                data-wow-duration="1.5s"
                data-wow-delay=".5s"
              >
                <span>Register your Tree</span>
                <i className="fa-solid fa-angles-right"></i>
              </a> */}
              <Link
                to="/upload"
                className="btn-one wow fadeInUp"
                data-wow-duration="1.5s"
                data-wow-delay=".5s"
              >
                <span>Register your Tree</span>
                <i className="fa-solid fa-angles-right"></i>
              </Link>
              <div><br></br></div>
            </div>
          </div>
        </div>
      </section>


    </div>
  );
};

export default Statistics;